<template>
  <div class="mw-panel">

    <div  :class="{'mw-pagination__body': pagination,'mw-no-pagination__body': !pagination, 'mw-panel': !pagination}">

    <el-table  ref='multipleTable' :class="{ 'mw-table':true,'mw-nowrap':!nowrap, 'mw-single-select':singleSelect}"  :border="border" :data="dataList"
    :show-header="showHeader"   v-loading="loading" @sort-change="sortChange" :row-style="rowStyle"
    @select="select"   @select-all="selectAll"  @row-click ="rowClick"    @selection-change="selectChange"
    @row-dblclick="rowDblClick" highlight-current-row  :row-key="getRowKeys" @expand-change="rowExpandChange">
    <el-table-column type="expand" width="30" class-name="mw-col-expand" v-if="showRowExpander">
       <template slot-scope="props">
         <div class="mw-row-expand-container"></div>
       </template>
     </el-table-column>

      <template v-for="(item,index) in columns">
        <el-table-column
          :prop="item.prop"
          :label="item.label?item.label:('index'==item.type?$lang('序号'):undefined)"
          :key="item.id+currentKey+index"
          :type="item.type"
          :resizable="true"
          :align="item.align"
          :header-align="item.headerAlign"
          :fixed="item.fixed"
          :selectable="_rowSelectable"
          :reserve-selection="item.reserve ? true: false"
          :show-overflow-tooltip="('selection'==item.type || ('index'==item.type))?false:(item.noTooltip?false:true)"
          :formatter="item.formatter"
          :class-name="item.className"
          :label-class-name="item.labelClassName"
          :width="(item.width?(item.autoWidth?undefined:item.width):('selection'==item.type)?'35':('index'==item.type)?55:undefined)"
          :min-width="item.minWidth ? item.minWidth:undefined"
          :sortable = "(item.sortable ?item.sortable:undefined)"
          @sort-change="(item.sortable ?'sortChange':undefined)"
          v-if="item.slot==undefined && item.slotName==undefined">
        </el-table-column>
        <el-table-column
          :prop="item.prop"
          :label="item.label"
          :key="item.id+currentKey+index"
          :type="item.type"
          :resizable="true"
          :align="item.align"
          :header-align="item.headerAlign"
          :fixed="item.fixed"
          :show-overflow-tooltip="item.noTooltip?false:true"
          :class-name="item.className"
          :label-class-name="item.labelClassName"
          :width="item.width?(item.autoWidth?undefined:item.width):undefined"
          :min-width="item.minWidth ? item.minWidth:undefined"
          :sortable = "(item.sortable ?item.sortable:undefined)"
          v-else-if="item.slotName!=undefined">
        <template  slot-scope="scope">
          <slot :name="item.slotName" :scope="scope">
          </slot>
        </template>
        </el-table-column>
        <el-table-column
          :prop="item.prop"
          :label="item.label"
          :key="item.id+currentKey+index"
          :type="item.type"
          :resizable="true"
          :align="item.align"
          :header-align="item.headerAlign"
          :fixed="item.fixed"
          :show-overflow-tooltip="item.noTooltip?false:true"
          :formatter="item.formatter"
          :class-name="item.className"
          :label-class-name="item.labelClassName"
          :width="item.width?(item.autoWidth?undefined:item.width):undefined" v-else-if="item.slot!=undefined"
          :min-width="item.minWidth ? item.minWidth:undefined"
          :sortable = "(item.sortable ?item.sortable:undefined)">
        <template slot-scope="scope" >
          <template v-if="item.slot['type']=='html'">
            <a @click="columnClick(item.slot.scope,scope,item.slot.func)" v-html="scope.row[item.prop]"></a>
          </template>
          <template v-else-if="item.slot['type']=='edit'">
            <el-input v-show="scope.row.$_edit?scope.row.$_edit:true" size="small" v-model="scope.row[item.prop]"></el-input>
            <span v-show="!scope.row.$_edit?scope.row.$_edit:true">{{ scope.row[item.prop]}}</span>
          </template>
          <template v-else-if="item.slot['type']=='button'">
            <el-button size="mini" class="mw-btn-mini" :key="'btnSlot'+index"
                       @click="it.func(scope.row,_getMe(),scope.$index)" v-for="(it,index) in item.slot.items">
                       <i v-if="it.icon" :class='it.icon'></i><span v-html="it.label"></span>
            </el-button>
          </template>

          <template v-else-if="item.slot['type']=='href'">
            <a @click="item.slot.func(scope.row,_getMe(),scope.$index)">{{item.slot.label?item.slot.label:scope.row[item.prop]}}</a>
          </template>

          <template v-else-if="item.slot['type']=='editableInput'">
            <double-face>
              <span slot="readonly">{{  scope.row[item.prop] }}&nbsp;</span>
              <span slot="editable">
              <el-input v-model="scope.row[item.prop]" @change="item.slot.func(scope.row,_getMe(),scope.$index)"></el-input>
            </span>
            </double-face>
          </template>
          <template v-else-if="item.slot['type']=='editableSelect'">
            <double-face>
              <span slot="readonly">{{  scope.row[item.prop] }}&nbsp;</span>
              <span slot="editable">
                <span v-if="scope.row[item.prop+'__editable']==false" >
                    {{  scope.row[item.prop] }}
                </span>
                <el-select  v-else v-model="scope.row[item.prop]" :placeholder="$lang('请选择')" @change="item.slot.func(scope.row,_getMe(),scope.$index)">
                  <el-option
                    v-for="d in item.slot.options"
                    :key="d.value"
                    :label="d.label"
                    :value="d.value">
                  </el-option>
                </el-select>
              </span>
            </double-face>
          </template>
        </template>
        </el-table-column>
      </template>
    </el-table>
  </div>
  <mw-pagination @size-change="sizeChange" @current-change="currentChange"
  :total="total" :currentPage="currentPage" v-if="pagination" :pageSize="limit"></mw-pagination>
  </div>
</template>
<script>
  import table from './table'
  export default table;
</script>



// WEBPACK FOOTER //
// src/common/components/extend/table/index.vue